module.exports = __webpack_public_path__ + "img/label-icon.0f2f5dca.png";